import React from 'react';
import go from './favicon.png';

const footerStyles = {
  display: 'none',
  width: '100%',
  display: 'block',
  justifyContent: 'center',
  alignItems: 'center',
  paddingBottom: '2px', 
  fontSize: '14px',
  color: '#888',
  position: "fixed",
  bottom: "0",
  textAlign: "center",
};

const imageStyles = {
  width: '20px',
  height: '20px',
  marginRight: '8px',
};

function Footer() {
  return (
    <div >
      {/* <img src={go} alt='kl' style={imageStyles} /> */}
  
    </div>
  );
}

export default Footer;
